import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DateBox from 'devextreme-react/date-box';
import './index.scss';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

const DatePicker = ({
	placeholder,
	validationStatus,
	onChange,
	error,
	defaultValue,
	type = 'date',
	showLabel = true,
	info,
	...props
}) => {
	const [fieldValue, setFieldValue] = useState(null);
	useEffect(() => {
		if (defaultValue) {
			setFieldValue(defaultValue);
		}
	}, [defaultValue]);
	return (
		<>
			{showLabel && (
				<label className='form-label d-flex'>
					{placeholder}
					{info && (
						<Tooltip title={info}>
							<InfoCircleFilled className='mx-1' />
						</Tooltip>
					)}
				</label>
			)}
			<DateBox
				defaultValue={defaultValue}
				type='date'
				pickerType='calendar'
				validationStatus={validationStatus}
				labelMode='static'
				onValueChanged={e => {
					setFieldValue(e.value);
					onChange(e.value);
				}}
				displayFormat='d MMM yyyy'
				dateSerializationFormat={type === 'date' ? 'yyyy-MM-dd' : 'HH:mm'}
				value={fieldValue}
				placeholder={placeholder}
				openOnFieldClick={true}
				{...props}
			/>
			{error && error.message && <div className='invalid-feedback d-block mb-2'>{error.message}</div>}
		</>
	);
};

DatePicker.propTypes = {
	type: PropTypes.string,
	validationStatus: PropTypes.string,
	defaultValue: PropTypes.string,
	error: PropTypes.object,
	onChange: PropTypes.func,
	placeholder: PropTypes.string.isRequired
};
export default DatePicker;
